import { httpPost } from "../../../../libs/http/httpPost"
import { UserRegisterPostInputModel } from "./PostInputModel"

export const postUserRegister = async (
  model: UserRegisterPostInputModel,
): Promise<void> => {
  return httpPost<void>("/v1/user/register", model)
}
